import type {Cardinality} from 'schemaDefinition/types';

export const isMultiple = (cardinality?: Cardinality): boolean =>
  !!cardinality && cardinality !== 'single';
